<template>
  <div>
    <v-overlay v-show="loader">Cargando </v-overlay>
    <v-form @submit.prevent="checkForm">
      <!-- Campo de Nombre -->
      <v-col cols="12" class="pb-0">
        <v-text-field
          v-model="Nombre"
          label="Nombre"
          placeholder="Nombre temporada"
          :error-messages="errors.nombre ? [errors.nombre] : []"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>

      <!-- Fecha Inicio -->
      <v-col cols="12" md="12">
        <label>Fecha Inicio</label>
        <div style="border-bottom: 1px solid; margin-bottom: -1px">
          <Datepicker
            :input-class="'v-input__control theme--light v-text-field dateinputClass'"
            @selected="selectDate"
            :value="input_date.format('MM/DD/YYYY')"
          ></Datepicker>
        </div>
      </v-col>

      <!-- Fecha Final -->
      <v-col cols="12" md="12" >
        <label>Fecha Final</label>
        <div style="border-bottom: 1px solid; margin-bottom: -1px">
          <Datepicker
            :input-class="'v-input__control theme--light v-text-field dateinputClass'"
            @selected="selectDateFinal"
            :disabled-dates="disableDates"
            :value="input_date_final.format('MM/DD/YYYY')"
          ></Datepicker>
        </div>
      </v-col>

      <!-- Checkbox de Activo -->
      <v-col cols="12" class="pb-0">
        <v-checkbox v-model="status" label="Activo"></v-checkbox>
      </v-col>

      <!-- Botones -->
      <v-col cols="12" class="text-right">
        <v-btn color="green" dark type="submit">Guardar</v-btn>
        <v-btn color="red" dark @click="$emit('toggle', false)">Cancelar</v-btn>
      </v-col>
    </v-form>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "invResForm",
  components: {
    Datepicker,
  },
  props: ["edit", "dataEdit"],
  data() {
    return {
      Nombre: "",
      input_date: moment(),
      input_date_final: moment(),
      status: true,
      loader: true,
      modProshop: false,
      modClubPlaya: false,
      modRestaurante: false,
      errors: {},
      Id: "",
    };
  },
  methods: {
    selectDate(arg) {
      this.input_date = moment(arg);
      if (this.input_date > this.input_date_final) {
        this.input_date_final = moment(arg);
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.Nombre) {
        this.errors.nombre = "El nombre de la tarifa es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    disableDates() {
      return { to: new Date(this.input_date) };
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    //this.getCategories();
    this.loader = false;
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Nombre = this.dataEdit.Nombre;
      this.input_date = new moment(this.dataEdit.FechaInicio, "YYYY-MM-DD");
      this.input_date_final = new moment(
        this.dataEdit.FechaTermino,
        "YYYY-MM-DD"
      );
      this.status = this.dataEdit.Activo;
    }
  },
};
</script>

<style scoped>
::v-deep .vdp-datepicker__calendar {
  position: fixed !important;
  width: 300px !important;
}
</style>
